<template>
  <div class="sme-button">
    <button
      :type="type"
      :disabled="disabled"
      @click="handleClick"
    >
      <slot></slot>
    </button>
  </div>
</template>

<script>
export default {
  name: 'sme-button',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleClick (event) {
      this.$emit('click', event)
    }
  }
}
</script>

<style lang="scss">
$primary-color: #39f;

.sme-button {
  display: inline-block;
  line-height: normal;
  vertical-align: middle;

  button {
    height: 25px;
    line-height: 24px;
    padding: 0px 12px;
    border: 1px solid $primary-color;
    border-radius: 2px;
    background-color: $primary-color;
    color: #fff;
    font-size: 12px;
    outline: none;
    cursor: pointer;
    box-sizing: border-box;

    &:hover {
      background-color: darken($primary-color, 10);
      border-color: darken($primary-color, 10);
    }
  }
}
</style>
